import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormNavigation } from '@fmnts/api/next';
import { I18nModule } from '@fmnts/i18n';

@Component({
  selector: 'next-form-actions',
  templateUrl: './form-actions.component.html',
  standalone: true,
  imports: [I18nModule],
})
export class FormActionsComponent {
  @Input() actions: FormNavigation[] = [];

  /** Array of actions that are disabled */
  @Input() disabled: string[] = [];

  @Output() action = new EventEmitter<string>();

  isDisabled({ action }: FormNavigation) {
    return this.disabled.includes(action);
  }

  handleAction(action: string) {
    this.action.emit(action);
  }
}
